import { Roles } from 'utils/authHelpers';
import { Auth, App } from '../containers';

const indexRoutes = [
  { path: '/login', container: Auth, requireAuth: false },
  { path: '/resetPassword', container: Auth, requireAuth: false },
  { path: '/resetPasswordRequest', container: Auth, requireAuth: false },
  { path: '/register', container: Auth, requireAuth: false },
  { path: '/fields', container: App, requireAuth: true },
  { path: '/user', container: App, requireAuth: true },
  { path: '/health', container: Auth, requireAuth: false },
  { path: '/admin', container: App, requireAuth: true, requiredRoles: [Roles.Super, Roles.Admin] },
  { path: '/', container: App, requireAuth: true },
];

export { indexRoutes }; // eslint-disable-line
